// Which agent control the supplemental and off-market Add/Edit forms render (MAX-4194).
//
// Derived server-side and returned on both list resources as `agentControl`, so the decision is
// made once rather than composed from two booleans per form. The old shape —
// `officeAccount && showAgentPageColumn` for the dropdown, `officeAccount && !showAgentPageColumn`
// for the free-text box — let Featured Property Type (a *display* setting) veto the dropdown for
// an account whose billing entitles it, which is the bug this ticket fixed. It also had a state
// where both controls rendered at once.
//
// These spellings are a wire contract with ihf-root's AbstractController constants. Nothing
// automated checks the Java<->TS match, and a drift presents as "the control never renders".
//
// The wire field stays typed `string` on the resource interfaces; the reducers narrow it with
// `isAgentControl` and everything downstream — state, selectors, props, the payload helper —
// deals in this closed union.

export type AgentControl = "dropdown" | "freeText" | "none";

const AGENT_CONTROLS: readonly AgentControl[] = ["dropdown", "freeText", "none"];

/**
 * Membership test, deliberately not a `??` fallback: `??` fires only on null/undefined, so an
 * unrecognised *string* — a fourth mode shipped by a newer server — would pass straight through
 * and leave both `=== "dropdown"` and `=== "freeText"` false, blanking the control entirely.
 * That is precisely the failure this guards against.
 */
export const isAgentControl = (value: unknown): value is AgentControl =>
	typeof value === "string" && (AGENT_CONTROLS as readonly string[]).includes(value);
